import gql from 'graphql-tag'

export const APPROVE_EXPENSE_BILLING_STATUS = gql`
  query approveExpenseBillingStatus(
    $expenseQuickbooksId: String!
    $billingStatus: String!
    $approveState: ApproveStateInput!
  ) {
    approveExpenseBillingStatus(
      expenseQuickbooksId: $expenseQuickbooksId
      billingStatus: $billingStatus
      approveState: $approveState
    )
  }
`

export const UPDATE_EXPENSE = gql`
  query($_id: String!, $deferToMonth: String, $status: String) {
    updateExpense(_id: $_id, deferToMonth: $deferToMonth, status: $status) {
      _id
      quickbooksId
      quickbooksInvoiceId
      stacksQuickbooksInvoiceId
      personId
      projectId
      transactionDate
      incurredDate
      transactionNumber
      projectDetails
      sourceName
      memo
      account
      class
      billingStatus
      amount
      sectionId
      status
      category
      fullCategory
      originalAmount
      originalMemo
      originalProjectId
      source
      invoicingParent
      invoicingConstituents
      splitParent
      splitChildren
      createdBy
      parentType
      parentTxnDate
      parentDueDate
      parentRefNumber
      parentTotal
      parentMemo
      parentTxnID
      isPaid
      originalIncurredDate
      originalPersonId
      postingPeriod
      approveState {
        status
        rejectionReason
        modifiedBy
      }
      currencyIsoCode
      deferToMonth
    }
  }
`

export const SPLIT_EXPENSE = gql`
  mutation SplitExpense($expenseId: String!, $amounts: [Float!]!, $statusses: [String]!) {
    splitExpense(expenseId: $expenseId, amounts: $amounts, statusses: $statusses) {
      parent {
        _id
        quickbooksId
        quickbooksInvoiceId
        stacksQuickbooksInvoiceId
        personId
        projectId
        transactionDate
        incurredDate
        transactionNumber
        projectDetails
        sourceName
        memo
        account
        class
        billingStatus
        amount
        sectionId
        status
        category
        fullCategory
        originalAmount
        originalMemo
        originalProjectId
        source
        invoicingParent
        invoicingConstituents
        splitParent
        splitChildren
        createdBy
        parentType
        parentTxnDate
        parentDueDate
        parentRefNumber
        parentTotal
        parentMemo
        parentTxnID
        isPaid
        originalIncurredDate
        originalPersonId
        postingPeriod
        approveState {
          status
          rejectionReason
          modifiedBy
        }

        currencyIsoCode
        deferToMonth
      }
      child {
        _id
        quickbooksId
        quickbooksInvoiceId
        stacksQuickbooksInvoiceId
        personId
        projectId
        transactionDate
        incurredDate
        transactionNumber
        projectDetails
        sourceName
        memo
        account
        class
        billingStatus
        amount
        sectionId
        status
        category
        fullCategory
        originalAmount
        originalMemo
        originalProjectId
        source
        invoicingParent
        invoicingConstituents
        splitParent
        splitChildren
        createdBy
        parentType
        parentTxnDate
        parentDueDate
        parentRefNumber
        parentTotal
        parentMemo
        parentTxnID
        isPaid
        originalIncurredDate
        originalPersonId
        postingPeriod
        approveState {
          status
          rejectionReason
          modifiedBy
        }
        currencyIsoCode
        deferToMonth
      }
    }
  }
`
